import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

function NotFound({ title, back }: { title: string; back: ReactNode }) {
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title={title}
      description="It may have been deleted, or the link is out of date."
      action={
        <Button variant="outline" asChild>
          {back}
        </Button>
      }
    />
  );
}

export const UserNotFound = () => <NotFound title="User not found" back={<Link to="/users">Back to users</Link>} />;
export const DemoUserNotFound = () => (
  <NotFound title="Demo user not found" back={<Link to="/demo-area">Back to the demo area</Link>} />
);
export const AuditEntryNotFound = () => (
  <NotFound title="Audit entry not found" back={<Link to="/audit">Back to the audit log</Link>} />
);
export const AccessEntryNotFound = () => (
  <NotFound title="Access log entry not found" back={<Link to="/access-log">Back to the access log</Link>} />
);
